import { Component } from '@angular/core'
import { HttpResponseHandlerService } from "../../../../../services/http-response-handler.service"
import { HelperService } from "../../../../../services/helper.service"

@Component({
  selector: 'app-copy-url',
  templateUrl: './copy-url.component.html',
  standalone: false
})
export class CopyUrlComponent {

  constructor(
    private responseHandlerService: HttpResponseHandlerService,
  ) {}

  public onCopyURL(): void {
    const url: string = window.location.href
    HelperService.copyMessage(url)
    this.responseHandlerService.notifySuccess('URL copied to clipboard!', '')
  }
}
